@if (stage == 1) {
  <h2 class="text-center">{{'main.mfa.dialog.title1' | translate}}</h2>
}

@if (stage == 1) {
  <p class="mt-3 text-sm">
    {{'main.mfa.dialog.desc1.part1' | translate}}
    <b>{{'main.mfa.dialog.desc1.part2' | translate}}</b>
    {{'main.mfa.dialog.desc1.part3' | translate}}
    <b>{{'main.mfa.dialog.desc1.part4' | translate}}</b>
    {{'main.mfa.dialog.desc1.part5' | translate}}
  </p>
}

@if (stage == 2) {
  <h2 class="text-center">{{'main.mfa.dialog.title2' | translate}}</h2>
}

@if (stage == 1) {
  <div class="img-container">
    <img [src]="$safeNavigationMigration(mfaSetup?.qrCodeUri)">
  </div>
}

@if (stage == 1) {
  <div class="mt-auto flex items-center justify-between">
    <div></div>
    <button class="btn blue" (click)="next()">{{'main.button.next' | translate}}</button>
  </div>
}

@if (stage == 2) {
  <div class="p-5 flex" style="height: 100%">
    <app-mfa-num-pad class="items-center" (value)="inputEmit($event)"></app-mfa-num-pad>
  </div>
}

@if (stage == 2 && errored) {
  <p class="text-red-600 mb-5 text-center text-lg">{{'main.mfa.dialog.error' | translate}}</p>
}

@if (stage == 2) {
  <div class="mt-auto flex items-center justify-between">
    <button class="btn blue" (click)="back()">{{'main.button.back' | translate}}</button>
    <button class="btn blue" (click)="done()" [disabled]="disabled">{{'main.button.submit' | translate}}</button>
  </div>
}

